var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-text"},[_c('li',[_vm._v("Green line: The "+_vm._s(_vm.currentDataText)+" is > 1 s.d. above the "+_vm._s(_vm.referenceDataText)+" historical data")]),_c('li',[_vm._v("Red line: The "+_vm._s(_vm.currentDataText)+" is < 1 s.d. below the "+_vm._s(_vm.referenceDataText)+" historical data")])])
}
var staticRenderFns = []

export { render, staticRenderFns }